import {
  SUBMIT_COMPETITOR_LIST_REQUEST,
  SUBMIT_COMPETITOR_LIST_SUCCESS,
  SUBMIT_COMPETITOR_LIST_FAILURE,
} from "../actions/competitorListActions";

const initialState = {
  loading: false,
  data: null,
  error: null,
};

const competitorListReducer = (state = initialState, action) => {
  switch (action.type) {
    case SUBMIT_COMPETITOR_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        data: null,
        error: null,
      };
    case SUBMIT_COMPETITOR_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case SUBMIT_COMPETITOR_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        data: null,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default competitorListReducer;
